<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="subject">{{subject.name}}</template><template v-if="subject && subject.unit">(单位:{{subject.unit}})</template> - 明细账 </span>
      <span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
			<div class="float-right">
<!--				<Checkbox :disabled="numPriceDisabled" v-model="showNumPrice">显示数量金额</Checkbox>-->
        <Button :loading="loading" @click="exportExcel">导出明细</Button>
			</div>
		</div>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1" style="overflow-x: auto;">
				<table class="cus-table" v-if="!showNumPrice">
					<thead class="header">
					<tr>
						<td>日期</td>
						<td>凭证字号</td>
						<td>科目</td>
						<td>摘要</td>
						<td>借方</td>
						<td>贷方</td>
						<td>方向</td>
						<td>余额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in datalist" :key="item.subjecId">
						<td>{{item.voucherDate}}</td>
						<td>
							<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
						</td>
						<td>{{item.subjectName}}</td>
						<td>{{item.summary}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-center">{{item.balanceDirection}}</td>
						<td class="text-right">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!datalist.length">
						<td colspan="8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
				<table class="cus-table" style="width: 1550px;" v-else>
					<thead class="header">
					<tr>
						<td rowspan="2" width="100">日期</td>
						<td rowspan="2" width="100">凭证字号</td>
						<td rowspan="2" width="150">科目</td>
						<td rowspan="2" width="200">摘要</td>
						<td colspan="3">借方发生额</td>
						<td colspan="3">贷方发生额</td>
						<td colspan="4">余额</td>
					</tr>
					<tr>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
						<td width="100">方向</td>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in datalist" :key="item.subjecId">
						<td>{{item.voucherDate}}</td>
						<td>
							<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
						</td>
						<td class="nowrap">{{item.subjectName}}</td>
						<td class="nowrap">{{item.summary}}</td>
						<td class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.num:''}}</td>
						<td class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.price:''}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.num:''}}</td>
						<td class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.price:''}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-center">{{item.balanceDirection}}</td>
						<td class="text-right">{{item.numBalance|numFormat}}</td>
						<td class="text-right">{{item.price|numFormat}}</td>
						<td class="text-right">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!datalist.length">
						<td colspan="8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			</Cell>
			<Cell v-width="200">
				<Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
import * as XLSX from 'xlsx';
  /**
   *  明细账
   */
	export default {
		name: 'DetailedAccounts',
		data() {
			return {
				loading: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'subjectFullName',
					dataMode: 'list',
					datas: []
				},
				datalist: [],
				subjectId: null,
				showNumPrice: false,
				numPriceDisabled: true,
				accountDate: null,
				subject: null
			};
		},
		watch: {
      /**
       * 处理科目变化的函数
       * 无参数
       * 无返回值
       * 根据科目单位信息控制数量价格显示状态，并在状态变化时加载列表数据
       */
			subject() {
				let org = this.showNumPrice;
        // 如果科目有单位信息，则启用数量价格并显示，否则隐藏数量价格显示
				if (this.subject.unit) {
					this.numPriceDisabled = false;
					this.showNumPrice = true;
				} else {
					this.showNumPrice = false;
				}
        // 当显示模式没有改变时，重新加载列表
				if (org == this.showNumPrice) {
					this.loadList();
				}
			},
      /**
       * 处理数量价格显示变化的函数
       * 无参数
       * 无返回值
       * 当数量价格显示状态改变时重新加载列表数据
       */
			showNumPrice() {
				this.loadList();
			},
      /**
       * 处理账户日期变化的函数
       * 无参数
       * 无返回值
       * 当账户日期发生变化时重新加载科目数据
       */
			accountDate() {
				this.loadSubject();
			}
		},
		methods: {
      /**
       * 导出明细数据为Excel文件
       */
      async exportExcel() {
        if (!this.datalist || this.datalist.length === 0) {
          this.$Message.warning('暂无数据可导出');
          return;
        }

        this.loading = true;
        try {
          // 动态导入xlsx库
          const XLSX = await import('xlsx');

          // 准备导出数据（统一使用标准格式）
          const exportData = this.datalist.map(item => {
            return {
              '日期': item.voucherDate,
              '凭证字号': item.voucherId ? `${item.word}-${item.code}` : '',
              '科目': item.subjectName,
              '摘要': item.summary,
              '借方': item.debitAmount || 0,
              '贷方': item.creditAmount || 0,
              '方向': item.balanceDirection,
              '余额': item.balance || 0
            };
          });
          // 生成文件名
          const fileName = `${this.subject.name}明细账_${this.accountDate}.xlsx`;

          // 创建工作表和工作簿
          const worksheet = XLSX.utils.json_to_sheet(exportData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '明细账');

          // 设置列宽
          const colWidths = [];
          if (exportData.length > 0) {
            Object.keys(exportData[0]).forEach(key => {
              colWidths.push({ wch: Math.max(key.length, 12) });
            });
            worksheet['!cols'] = colWidths;
          }
          // 导出文件
          XLSX.writeFile(workbook, fileName);

          this.$Message.success('导出成功');
        } catch (error) {
          console.error('导出失败:', error);
          this.$Message.error('导出失败: ' + (error.message || '未知错误'));
        } finally {
          this.loading = false;
        }
      },

			loadSubject() {
				this.datalist = [];
				this.$api.accountbook.loadSubject({accountDate: this.accountDate}).then(({data}) => {
					this.$set(this.param, "datas", data);
					if (data.length) {
						this.subjectId = data[0].id;
						this.subject = data[0];
					}
				});
			},
      /**
       * 加载凭证明细列表数据
       *
       * @description 通过API接口获取指定条件下的凭证明细数据，并更新组件的数据列表
       * @param {string} accountDate - 会计日期，用于筛选指定日期的凭证数据
       * @param {string|number} subjectId - 科目ID，用于筛选指定科目的凭证数据
       * @param {boolean} showNumPrice - 是否显示数量和单价字段
       * @param {string} subject.code - 科目编码，用于API请求参数
       * @returns {Promise} API请求返回的Promise对象，包含凭证明细数据
       */
			loadList() {
        // 设置加载状态为true，显示加载动画
				this.loading = true;
        // 调用API接口加载凭证明细数据
				this.$api.accountbook.loadVoucherDetails({
					accountDate: this.accountDate,
					subjectId: this.subjectId,
					showNumPrice: this.showNumPrice,
					subjectCode: this.subject.code
				}).then(({data}) => {
          // 将获取到的数据赋值给组件的datalist属性
					this.datalist = data;
          // 数据加载完成，关闭加载状态
					this.loading = false;
				});
			},
      /**
       * 选择科目时的处理函数
       * @param {Object} node - 被选中的科目节点对象
       * @returns {void}
       */
			subjectSelect(node) {
				this.subject = node;
			}
		}
	};
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}
</style>